<template>
    <div>
        <img
            alt="Ideasfundx logo"
            src="../../../../assets/img/m-2.png"
            class=""
        />
        <div class="mt-3">
            <div class="d-flex gap-3">
                <p style="color: #000">HQ Address</p>
                <span class="ms-6" style="color: gray">{{ describe.zip }} {{ describe.city }} {{ describe.country }}</span>
            </div>

            <p class="text-sm-left">Specific founding team profile</p>
            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left mt-2 ml-3" style="color: #000">Female founder</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="policies.female ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="not_color ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left mt-2 ml-3" style="color: #000">Founder of color</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="policies.color ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="not_female ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="3">
                    <p class="text-sm-left mt-2 ml-3" style="color: #000">LGBTQ founder</p>
                </v-col>

                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="policies.lgbtq ? 'primary' : ''">
                        YES
                    </v-btn>
                </v-col>
                <v-col cols="6" sm="3">
                    <v-btn
                    v-bind:color="not_lgbtq ? 'primary' : ''">
                        NO
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
    import CompanyService from "@/store/services/company/company.service";
    import TeamsService from "@/store/services/teams.service";

    export default {
        props: {
            company_id: Number,
        },
        components : {},
        data() {
            return {
                not_female: false,
                not_color: false,
                not_lgbtq: false,
                describe: {
                    company_name: "",
                    gender: "Mr.",
                    first_name: "",
                    last_name: "",
                    country: "",
                    street: "",
                    zip: "",
                    city: "",
                    phone: null,
                    date_incorporation: "",
                },
                policies: {
                    female: null,
                    color: null,
                    lgbtq: null,
                },
            }
        },

        mounted () {
            CompanyService.getDescribeById(this.company_id).then((res) => {
                if (res.data) {
                    this.describe.company_name = res.data.company_name;
                    this.describe.gender = res.data.gender;
                    this.describe.first_name = res.data.first_name;
                    this.describe.last_name = res.data.last_name;
                    this.describe.country = res.data.country;
                    this.describe.street = res.data.street;
                    this.describe.zip = res.data.zip;
                    this.describe.city = res.data.city;
                    this.describe.date_incorporation = res.data.date_incorporation;
                    this.describe.phone = res.data.phone;
                    this.phone = this.describe.phone;
                }
            });

            TeamsService.getPolicies(this.company_id).then((res) => {
                if (res.data.female != null) { this.policies.female = res.data.female; this.not_female = !res.data.female; }
                if (res.data.lgbtq != null) { this.policies.lgbtq = res.data.lgbtq; this.not_lgbtq = !res.data.lgbtq; }
                if (res.data.color != null) { this.policies.color = res.data.color; this.not_color = !res.data.color; }
            })
        }
    }
</script>